import React, { useState } from "react";
import httpClient from "../utils/httpClients";
import { useNavigate } from "react-router-dom";
import TopTost from "../utils/topTost";
import { toast } from "react-toastify";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading) return;

    if (!email) {
      TopTost.fire({
        icon: "error",
        title: "Please enter your email address",
      });
      return;
    }

    setIsLoading(true);

    try {
      const res = await httpClient.post("/common/auth/forgot-password", {
        email,
        userType: "User",
      });

      // if (res.data?.message) {
      //   toast.success(res.data.message, {
      //     autoClose: 3000,
      //     position: "top-right",
      //   });
      // }

      if (res.data?.data?.token) {
        localStorage.setItem("volumeAuthToken", res.data.data.token);
      }

      navigate("/verify-otp", { state: { email, type: "f" }, replace: true });
    } catch (err) {
      console.error("Forgot password error:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
      });
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Failed to send OTP. Please try again.";
      // TopTost.fire({
      //   icon: "error",
      //   title: errorMessage,
      // });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wrapper">
      <section className="login-content overflow-hidden">
        <div className="row no-gutters align-items-center bg-white">
          <div className="col-md-12 col-lg-6 align-self-center">
            <a
              href="/"
              className="navbar-brand d-flex pt-5 align-items-center mb-3 justify-content-center text-primary"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                alt="Logo"
              />{" "}
            </a>
            <div className="row justify-content-center pt-5 px-4">
              <div className="col-md-9">
                <div className="card d-flex justify-content-center mb-0 auth-card iq-auth-form">
                  <div className="card-body">
                    <h2 className="mb-2 text-center">Forgot Password</h2>
                    <p className="text-center">
                      Enter your email and an OTP will be sent to you. Let's
                      access the best recommendations for you.
                    </p>

                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="email" className="form-label">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                              aria-describedby="email"
                              placeholder="xyz@example.com"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Sending OTP...
                            </>
                          ) : (
                            "Send OTP"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-lg-block d-none bg-primary p-0 overflow-hidden">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/auth/01.jpg`}
              className="img-fluid gradient-main"
              alt="login background"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ForgotPassword;
